
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './inicio.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pinicio = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id692858a5c419e6f0648ca21f" >

      <div id="iiyb" className="">
      
      <div id="im6f" className="">
      
      <div id="is4uc" className="">
      
      <img
        className=""
        id="icmn6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhky00z2.png"
        alt="undefined"
      />
      
      <div className="" id="ihbt6">
        <>+504 8805-8638 / +504 8735-8194</>
      </div>
      
      <img
        className=""
        id="ilgyi"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhky21kx.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="iaoea"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhky2ofv.png"
        alt="undefined"
      />
      
      <div className="" id="i1fmo">
        <>promomas.tgu@gmail.com</>
      </div>
      
      </div>
      
      </div>
      
      <div id="io8p" className="">
      
      <div id="iz11r" className="">
      
      <img
        className=""
        id="iqh9l"
        src="https://assetsprojects.s3.amazonaws.com/404pziimj76tl47.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ipi7" className="">
      
        <a
          target=""
          className=""
          id="i0rt5"
          href="/"
        >
          
    <div id="i5f7n" className="">
    <>Home</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i64qq"
          href="/catalogo"
        >
          
    <div id="i0v2r" className="">
    <>Catalogo</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iyoo9"
          href="/clientes"
        >
          
    <div id="i3bxm" className="">
    <>Clientes  y  Casos</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i366m"
          href="/contacto"
        >
          
    <div id="i3ztl" className="">
    <>Contacto</>
    </div>
    
        </a>
        
      </div>
      
      <div id="i2j0h" className="">
      
        <a
          target=""
          className=""
          id="iohmi"
          href="/carritocompras"
        >
          
    <div id="is0ki" className="">
    <>Carrito de Compra</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="izzx8y" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Home</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/catalogo"
        type=""
      >
        <>Catalogo</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/clientes"
        type=""
      >
        <>Clientes  y  Casos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      <div id="iwz9d6" className="">
      
      <img
        className=""
        id="igv25h"
        src="https://assetsprojects.s3.amazonaws.com/404pziimj76tl47.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iaebgw" className="">
      
        <a
          target=""
          className=""
          id="ipy0ca"
          href="/carritocompras"
        >
          
    <div id="izfo4g" className="">
    <>Carrito de Compra</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div
        id="ilspi5"
        className=""
        data-aos="fade-right"
        data-aos-duration="10"
      >
      
      <div id="i6pm" className="">
      
      <div id="iwt6w" className="">
      
      <div id="imoyi" className="">
      
      <div id="ijllf" className="">
      
      <img
        className=""
        id="in5vj"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhkymayg.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="icay7"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhkyny6c.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="ifpmh" className="">
      
      <div className="" id="inb91">
        <>Eleve su marca con nuestros servicios de impresión digital.</>
      </div>
      
      <div className="" id="iy50g">
        <>Somos especialistas en impresión de camisas y artículos personalizados, combinando calidad, creatividad y tecnología de punta.</>
      </div>
      
        <a
          target=""
          className=""
          id="i8i6g"
          href="/catalogo"
        >
          
    <div id="id20m" className="">
    <>Ver Catalogo</>
    </div>
    
        </a>
        
      </div>
      
      <div id="i8rg5" className="">
      
      <div id="i763f" className="">
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iycyi" className="">
      
      </div>
      
      <div
        id="irgf6i"
        className=""
        data-aos="fade-right"
        data-aos-duration="10"
      >
      
      <div id="itt0a" className="">
      
      <div id="issak" className="">
      
      <div id="i5tw44" className="">
      
      </div>
      
      <div id="ig8jfj" className="">
      
      </div>
      
      <div id="ieems8" className="">
      
      </div>
      
      </div>
      
      <div id="iwkyac" className="">
      
      <div id="iqxfnc" className="">
      
      <img
        className=""
        id="im2evl"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl20978.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="iik5hi" className="">
      
      <div className="" id="itk2ez">
        <>Acerca de Nosotros</>
      </div>
      
      <div className="" id="ii2586">
        <>Experimente el poder de la impresión digital</>
      </div>
      
      <div id="iiqv0p" className="">
      
      <div id="i2amqt" className="">
      
      </div>
      
      <div className="" id="ijxokp">
        <>Nuestro objetivo es ayudarte a expresar tu estilo, tu marca o tu evento con productos que destacan por su durabilidad y diseño profesional.</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iez54g" className="">
      
      <img
        className=""
        id="i8zjhf"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl2i5hj.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div
        id="i3s482"
        className=""
        data-aos="fade-right"
        data-aos-duration="10"
      >
      
      <div id="id66xn" className="">
      
      <div id="i2suax" className="">
      
      <div id="iwkl0f" className="">
      
      <div className="" id="ig9tjq">
        <>Servicios</>
      </div>
      
      <div className="" id="ipc9i7">
        <>Ofrecemos</>
      </div>
      
      </div>
      
      <div id="ieevr8" className="">
      
        <a
          target=""
          className=""
          id="i2afm6"
          href="/catalogo"
        >
          
    <div id="i80k3o" className="">
    <>Ver más</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="i1hzxh" className="">
      
      <div id="i1p3xw" className="">
      
      <div id="ixni9i" className="">
      
      <img
        className=""
        id="ite29n"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl357vl.jpg"
        alt="undefined"
      />
      
      <div id="iuh2t3" className="">
      
      <div id="iq4vwu" className="">
      
      <img
        className=""
        id="izgkwo"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl42t90.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i0wcd5">
        <>Impresión en camisetas, sudaderas, gorras y más.</>
      </div>
      
      </div>
      
      </div>
      
      <div id="idkw49" className="">
      
      <div id="ijbrpg" className="">
      
      <div className="" id="ievwrc">
        <>Servicios de serigrafía, sublimación y vinil textil.</>
      </div>
      
      <div id="ipvj9d" className="">
      
      <img
        className=""
        id="ivy6vz"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl3tqw1.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <img
        className=""
        id="ib8jqr"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl35qox.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iv4606" className="">
      
      <img
        className=""
        id="idhauv"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl36gkf.jpg"
        alt="undefined"
      />
      
      <div id="ivlxjj" className="">
      
      <div id="ivr04g" className="">
      
      <img
        className=""
        id="ir4px5"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl42t90.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="incta5">
        <>Producción en pequeñas y grandes cantidades.</>
      </div>
      
      </div>
      
      </div>
      
      <div id="ij34rl" className="">
      
      <div id="iw9nsu" className="">
      
      <div className="" id="iph3cg">
        <>Diseños personalizados para empresas, grupos, eventos y uso personal.</>
      </div>
      
      <div id="iv6y4x" className="">
      
      <img
        className=""
        id="i39un6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl3tqw1.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <img
        className=""
        id="iz3ywm"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl3944r.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div
        id="i6ehs8"
        className=""
        data-aos="fade-up-right"
        data-aos-duration="10"
      >
      
      <div id="iw4u9l" className="">
      
      <div id="iqqzgm" className="">
      
      <div id="ibadhi" className="">
      
      <div id="i4apz7" className="">
      
      <div className="" id="iks21d">
        <>Impresiones digitales rápidas, económicas y de alta calidad ¿Por qué no?</>
      </div>
      
      </div>
      
      </div>
      
      <div id="i3u944" className="">
      
      <div id="i7m2r7" className="">
      
      <div id="iw2p2y" className="">
      
      <img
        className=""
        id="icno5k"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl6rjlo.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iyyn9l" className="">
      
      <div className="" id="ies9qj">
        <>Tecnología moderna</>
      </div>
      
      </div>
      
      </div>
      
      <div id="iub28f" className="">
      
      <img
        className=""
        id="iil9cw"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl6nrxc.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="inl1rf" className="">
      
      <div id="i4i0hr" className="">
      
      <img
        className=""
        id="ixzncc"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl6vydj.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iuijk3" className="">
      
      <div className="" id="isatcx">
        <>Velocidad y precisión</>
      </div>
      
      </div>
      
      </div>
      
      <div id="i6l1mz" className="">
      
      <img
        className=""
        id="i4fc2h"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl6nrxc.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="id0bah" className="">
      
      <div id="ius6iz" className="">
      
      <img
        className=""
        id="i16f1c"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl6we7r.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ivtnv6" className="">
      
      <div className="" id="i16kfc">
        <>Profesional Equipo</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iyhhsv" className="">
      
      <div id="iak3iy" className="">
      
      <div id="iguw1t" className="">
      
      <div className="" id="imo2qf">
        <>! Obtenga una oferta especial hoy !</>
      </div>
      
        <a
          target=""
          className=""
          id="ih0i97"
          href="/contacto"
        >
          
    <div id="ink8zk" className="">
    <>Contáctanos</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div
        id="inaj4g"
        className=""
        data-aos="fade-up-right"
        data-aos-duration="10"
      >
      
      <div id="iby3j5" className="">
      
      <div id="izqpmt" className="">
      
      <div className="" id="i5ujh1">
        <>Empresas Que Confian En Nosotros</>
      </div>
      
      </div>
      
      <div id="i3wxa1" className="">
      
      <div id="ipbnby" className="">
      
      <img
        className=""
        id="ibk17g"
        src="https://assetsprojects.s3.amazonaws.com/404pziimj77h70v.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i0u202" className="">
      
      <img
        className=""
        id="ild1os"
        src="https://assetsprojects.s3.amazonaws.com/404pziimj77hxz7.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iuy8zw" className="">
      
      <img
        className=""
        id="i1z8a3"
        src="https://assetsprojects.s3.amazonaws.com/404pziimj77j73g.jpeg"
        alt="undefined"
      />
      
      </div>
      
      <div id="i85odz" className="">
      
      <img
        className=""
        id="ixbqc2"
        src="https://assetsprojects.s3.amazonaws.com/404pziimj77jkkh.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i394fh" className="">
      
      <img
        className=""
        id="ic6w9w"
        src="https://assetsprojects.s3.amazonaws.com/404pziimj77k8jg.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iddlkx" className="">
      
      <img
        className=""
        id="idxjab"
        src="https://assetsprojects.s3.amazonaws.com/404pziimj77l07p.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ilg1my" className="">
      
      <img
        className=""
        id="i30acv"
        src="https://assetsprojects.s3.amazonaws.com/404pziimj77mayx.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="itilhi" className="">
      
      <img
        className=""
        id="ixuxsu"
        src="https://assetsprojects.s3.amazonaws.com/404pziimj77n4m2.jpg"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ixwk4o" className="">
      
      <div id="iiww8m" className="">
      
      <div className="" id="ifv21g">
        <>PROMOMÁS</>
      </div>
      
      </div>
      
      <div id="iqia8d" className="">
      
      <img
        className=""
        id="idg28o"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl8hqoi.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iuttse" className="">
      
      <div id="i25xem" className="">
      
      <div className="" id="imteyo">
        <>Servicios</>
      </div>
      
        <a
          target=""
          className=""
          id="iy78h4"
          href="#"
        >
          
    <div id="izbti2" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i0xii1">
        <>Impresión Digital</>
      </span>
      
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ipqz1l"
          href="#"
        >
          
    <div id="inoqdq" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ilmxx8">
        <>Impresión Empresarial</>
      </span>
      
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ir56kh"
          href="#"
        >
          
    <div id="ias9g8" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ieztyk">
        <>Impresión Camisas</>
      </span>
      
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="itdtwi"
          href="#"
        >
          
    <div id="i6g3qf" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="itz8r7">
        <>Impresión Vinil</>
      </span>
      
    </div>
    
        </a>
        
      </div>
      
      <div id="iuud1b" className="">
      
      <div className="" id="i7yb3u">
        <>Links</>
      </div>
      
        <a
          target=""
          className=""
          id="ikbm9q"
          href="#"
        >
          
    <div id="ind5fe" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="icv9sr">
        <>Términos de Uso</>
      </span>
      
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ia59al"
          href="#"
        >
          
    <div id="irnnqo" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="id6hyi">
        <>Política de privacidad</>
      </span>
      
    </div>
    
        </a>
        
      </div>
      
      <div id="i73f12" className="">
      
      <div className="" id="i2lbvh">
        <>Contacto</>
      </div>
      
      <div id="i466ik" className="">
      
      <img
        className=""
        id="i62w5l"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl9awu5.png"
        alt="undefined"
      />
      
      <div className="" id="iewlbx">
        <>+504 8805-8638 / +504 8735-8194</>
      </div>
      
      </div>
      
      <div id="idh5ss" className="">
      
      <img
        className=""
        id="izotfk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl9gu29.png"
        alt="undefined"
      />
      
      <div className="" id="izb5r9">
        <>promomas.tgu@gmail.com</>
      </div>
      
      </div>
      
      <div id="iqhlmx" className="">
      
      <img
        className=""
        id="iqw36b"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl9gu29.png"
        alt="undefined"
      />
      
      <div className="" id="il620y">
        <>Res. El molinón, Tegucigalpa, Honduras</>
      </div>
      
      </div>
      
      </div>
      
      <div id="ip8fzp" className="">
      
      <div className="" id="ichv08">
        <>Ubicación</>
      </div>
      
      <div id="iqgohk" className="">
      
      <iframe
        title="Mapa"
        className=""
        id="io2gc7"
        frameBorder="0"
        src="https://maps.google.com/maps?&q=Res. El molinón, Tegucigalpa, Honduras&z=10&t=q&output=embed"
      />
      
      </div>
      
      </div>
      
      <div id="i5b5b3" className="">
      
      <div className="" id="iz6anw">
        <>Redes Sociales</>
      </div>
      
      <div id="ihi4ns" className="">
      
      <img
        className=""
        id="ijd5dp"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl9tcox.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="isber5" className="">
      
      <img
        className=""
        id="i69api"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl8hqoi.png"
        alt="undefined"
      />
      
      <div className="" id="iotx6g">
        <>Promomás©2025    Todos los Derechos reservados</>
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pinicio);
  